export const BackChevron = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="12.638" height="22" viewBox="0 0 12.638 22">
        <path
            fill="#007AFF"
            d="M-6900.4,9462.119l-9.043-9.135a1.022,1.022,0,0,1-.114-.1l-.741-.747a1.018,1.018,0,0,1-.292-.724,1.021,1.021,0,0,1,.292-.724l.741-.748a1.007,1.007,0,0,1,.116-.1l9.042-9.133a.993.993,0,0,1,1.416,0l.741.748a1.019,1.019,0,0,1,0,1.429l-8.441,8.526,8.441,8.528a1.019,1.019,0,0,1,0,1.429l-.741.748a1,1,0,0,1-.708.295A1,1,0,0,1-6900.4,9462.119Z"
            transform="translate(6910.585 -9440.414)"
        />
    </svg>
);
